import { isNil } from 'lodash-es';
import * as immutable from 'object-path-immutable';
import { StateStepper } from '~core/models/shared.models';

export class StepperState {
  static init(state: Partial<StateStepper>): StateStepper {
    const currentStep = isNil(state.currentStep) ? 0 : state.currentStep;
    const totalSteps = isNil(state.totalSteps) ? 0 : state.totalSteps;

    return {
      currentStep:
        currentStep < 0 || currentStep > totalSteps ? 0 : currentStep,
      totalSteps: totalSteps < 0 || totalSteps < totalSteps ? 0 : totalSteps
    };
  }

  static goToPreviousStep(state: StateStepper): StateStepper {
    if (state.currentStep > 0) {
      return immutable.update(state, 'currentStep', step => step - 1);
    }

    return state;
  }

  static goToNextStep(state: StateStepper): StateStepper {
    if (state.currentStep < state.totalSteps - 1) {
      return immutable.update(state, 'currentStep', step => step + 1);
    }

    return state;
  }

  static goToStep(state: StateStepper, step: number): StateStepper {
    if (step >= 0 && step <= state.totalSteps) {
      return immutable.set(state, 'currentStep', step);
    }

    return state;
  }
}
